const LINE_MARKER = /^\s*\[(\d{1,3}(?::\d{2}){1,2})\]\s*(.*)$/;
const TAG_NAME = /#([\wа-яА-Яё]+)/g;

export const parseTimecode = (value) => {
  const parts = String(value)
    .split(":")
    .map((part) => Number(part));

  if (parts.length < 2 || parts.length > 3) return null;
  if (parts.some((part) => !Number.isFinite(part) || part < 0)) return null;

  const seconds = parts[parts.length - 1];
  if (seconds > 59) return null;

  if (parts.length === 2) {
    return parts[0] * 60 + seconds;
  }

  if (parts[1] > 59) return null;
  return parts[0] * 3600 + parts[1] * 60 + seconds;
};

export const extractTagNames = (text) => {
  const names = [];
  const regex = new RegExp(TAG_NAME.source, "g");

  let match;
  while ((match = regex.exec(text)) !== null) {
    if (!names.includes(match[1])) names.push(match[1]);
  }

  return names;
};

export const stripTagNames = (text) =>
  text
    .replace(new RegExp(TAG_NAME.source, "g"), " ")
    .replace(/\s+/g, " ")
    .trim();

export const parseCommentsFromText = (text, duration = 0) => {
  const comments = [];
  const leftover = [];

  const videoDuration = Number(duration);
  const hasDuration = Number.isFinite(videoDuration) && videoDuration > 0;

  String(text ?? "")
    .split(/\r?\n/)
    .forEach((line) => {
      const match = line.match(LINE_MARKER);

      if (!match) {
        if (line.trim()) leftover.push(line.trim());
        return;
      }

      const seconds = parseTimecode(match[1]);
      const body = (match[2] || "").trim();

      if (seconds === null || !stripTagNames(body)) {
        if (line.trim()) leftover.push(line.trim());
        return;
      }

      const beyondDuration = hasDuration && seconds > videoDuration;

      comments.push({
        timecode: beyondDuration ? "00:00" : match[1],
        seconds: beyondDuration ? 0 : seconds,
        body,
      });
    });

  return { comments, leftover: leftover.join("\n") };
};
